'use strict';

/**
 * An `AttributionControl` control presents the map's [attribution information](https://www.mapbox.com/help/attribution/).
 *
 * @implements {IControl}
 * @param {Object} [options]
 * @param {boolean} [options.compact] If `true` force a compact attribution that shows the full attribution on mouse hover, or if `false` force the full attribution control. The default is a responsive attribution that collapses when the map is less than 640 pixels wide.
 */
export default class AttributionControl {
  constructor(options) {
    this.options = options || {};
    this._attributions = options.attributions || [];
  }

  getDefaultPosition() {
    return 'bottom-right';
  }

  setAttributions(attributions) {
    this._attributions = attributions;
    this._updateAttributions();
  }

  onAdd(map) {
    this._map = map;
    this._container = window.document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-attrib';

    if (this.options.compact) {
      this._container.classList.add('compact');
    }

    this._updateAttributions();

    if (this.options.compact === undefined) {
      this._map.on('resize', this._updateCompact);
      this._updateCompact();
    }

    return this._container;
  }

  onRemove() {
    this._container.remove();

    this._map.off('resize', this._updateCompact);

    this._map = undefined;
  }

  _updateAttributions() {
    this._container.innerHTML = this._attributions.join(' | ');
  }

  _updateCompact = () => {
    if(this._map.getCanvasContainer().clientWidth <= 640)
      this._container.classList.add('compact');
    else
      this._container.classList.remove('compact');
  }
}
